window.GCITY_PARTNER_LOGOS = [
  {
    name: "Partner 01",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/9bd1c59465f85560259de6bbe215673f.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 01",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 02",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/8f7f725c584df561064ad0555c9b5026.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 02",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 03",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/5a604b59f29eff2db8954948b7e146c5.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 03",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 04",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/f51f227501194dffd8a63bcdf1e2dce8.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 04",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 05",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/a6c2589b91e339e527c2723c0fb8c4fd.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 05",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 06",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/7d656be5c10e7e8d13978c0e0bd2d8b6.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 06",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 07",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/6e0792b39e435f8aae72d78bf3c81245.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 07",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 08",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/7ebca34b6aaeb2468aac983015d43def.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 08",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 09",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/c24224d1cd09848db595c168417e65b5.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 09",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 10",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/b93ff18f621fdf26056807eb591eb266.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 10",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 11",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/9eeb89ebef491f3722cd6071233e9f8a.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 11",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 12",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/ec75e6c37455bfb982aad5799d9a44f2.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 12",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 13",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/16f2809e2c5d38785fa1cc2cf9676d25.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 13",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 14",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/2615d96e364e54e7314290e03677b9a1.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 14",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 15",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/b80210fd609963fe7a2f3bfd82f664b5.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 15",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 16",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/15d6839ff69378bdd81bcb4f94494be8.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 16",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 17",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/cc1d774d394d7b1fa29777811b28ae60.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 17",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 18",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/6e6cb282768fb01d68dcf52a35fe032a.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 18",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 19",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/8bf39d0e69e74472897f92ff20c94afd.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 19",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 20",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/b40bc4f1ff07100dbf63f5fd528dde22.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 20",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 21",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/920ac306d27941eafe030f4302a665f2.png?v=1778143873",
    alt: "GCityPartners ecosystem partner logo 21",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 22",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/0bc72953d1f3a7443a662add443c1ec0.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 22",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 23",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/aeb3fadf81b96dfe8362f82135186e97.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 23",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 24",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/1c4fdd4d0f264d91901cac4e4261adac.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 24",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 25",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/241864f5f89151c3005ff97d63c23105.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 25",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 26",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/4efa0faa17a11e81d1077967c7a14c57.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 26",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 27",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/75254937b39994ed84daa095f71477fd.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 27",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 28",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/6aab2dbd4c1119f85101bb02d1cc2d5f.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 28",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 29",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/c28e3878986e1d06a26213c8064545e9.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 29",
    type: "partner",
    featured: true
  },
  {
    name: "Partner 30",
    image: "https://cdn.shopify.com/s/files/1/0667/5762/3889/files/8b695ff6c299686453ebc3b89b4e4be3.png?v=1778143872",
    alt: "GCityPartners ecosystem partner logo 30",
    type: "partner",
    featured: true
  }
];
